import successIcon from '@assets/success.svg';
import { SandboxMessageScreen } from '@/components/Sandbox/SandboxMessageScreen/SandboxMessageScreen';

export const SandboxSuccessScreen = ({
  redirectUrl,
}: {
  redirectUrl?: string;
}) => {
  const body = redirectUrl
    ? 'You will now be taken to the sandbox to finish where you left off'
    : 'You can now continue in the sandbox on desktop';

  return (
    <SandboxMessageScreen
      title="AirKey verification successful"
      body={body}
      icon={successIcon}
    >
      {redirectUrl && (
        <a
          href={redirectUrl}
          style={{
            display: 'block',
            marginTop: '24px',
            color: 'white',
            textAlign: 'center',
          }}
        >
          Go to Sandbox
        </a>
      )}
    </SandboxMessageScreen>
  );
};
